import { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";

import { useActiveBrokerAccount } from "../../../hooks/useActiveBrokerAccount";
import { strategyNewReportPath } from "./workspaceNewReport";

/**
 * Opens Create report on a strategy's trades (`paper:<deployment>` / `backtest:<hypothesis>`):
 * on the strategy's Workspace canvas when it has one, else on Reports with the trades preselected.
 */
export function useOpenStrategyReport(): {
  openReport: (strategyId: string | null, tradeSource: string) => Promise<void>;
  opening: boolean;
} {
  const history = useHistory();
  const { activeAccountCode, activeBrokerName, setActiveTradeAccount } = useActiveBrokerAccount();
  const [opening, setOpening] = useState(false);
  const openReport = useCallback(
    async (strategyId: string | null, tradeSource: string) => {
      setOpening(true);
      try {
        const path = strategyId
          ? await strategyNewReportPath(strategyId, tradeSource, {
              brokerName: activeBrokerName,
              accountCode: activeAccountCode,
              setActiveTradeAccount,
            }).catch((err) => {
              console.warn("Could not open the strategy's canvas; using Reports", err);
              return null;
            })
          : null;
        history.push(
          path ??
            `/reports/new?trade_source=${encodeURIComponent(tradeSource)}` +
              (strategyId ? `&strategy_id=${encodeURIComponent(strategyId)}` : "")
        );
      } finally {
        setOpening(false);
      }
    },
    [activeAccountCode, activeBrokerName, history, setActiveTradeAccount]
  );
  return { openReport, opening };
}
